<div class='row'>
  <div class='col info-row'>
    <div class='info-column'>
      <div class='info-section'>
        <h5 class='info-title'>
          <span>App Information</span>
          <info-tooltip title='Detailed app specific information.'></info-tooltip>
        </h5>
        <div class='info-list-2'>
          <info-list-item label='Bundle Id' [lock]="isFreemium" [value]='data?.appOverview?.bundleId'
            [valueTooltip]='data?.appOverview?.bundleId'></info-list-item>

          <info-list-item label='IAB Primary Category' [lock]="isFreemium"
            [suggestionConfig]='{ type: "app", id: data?.appOverview?.appId, metricId: "appOverview.iabPrimaryCategory" }'
            [value]='data?.appOverview?.iabPrimaryCategory'
            (interact)='goToAppDiscovery( "iabPrimaryCategory", $event )'></info-list-item>

          <info-list-item label='IAB Subcategory' [lock]="isFreemium"
            [suggestionConfig]='{ type: "app", id: data?.appOverview?.appId, metricId: "appOverview.iabSubCategory" }'
            [value]='data?.appOverview?.iabSubCategory' (interact)='goToAppDiscovery( "iabSubCategory", $event )'>
          </info-list-item>

          <info-list-item label='App Store Page' [lock]="isFreemium" value='Go to App Store'
            [link]='data?.appOverview?.trackViewUrl' [valueTooltip]='data?.appOverview?.trackViewUrl'></info-list-item>

          <info-list-item label='Owner Domain' [lock]='isFreemium'
            labelTooltip="Business domain of the owner of the app, as declared in the corresponding app-ads.txt file.">
            <ng-container #value>
              <ng-container *ngIf="(!data?.appOverview?.ownerDomain
                || data?.appOverview?.ownerDomain === 'N/A'); else showOwnerDomainLink">
                N/A
              </ng-container>
              <ng-template #showOwnerDomainLink>
                <a class="btn btn-link p-0 external-link" target="_blank"
                  href="{{data?.appOverview?.ownerDomain | urlfix}}">
                  <span>{{data?.appOverview?.ownerDomain}} </span>
                  <i class="fa fa-external-link"></i>
                </a>
              </ng-template>
            </ng-container>
          </info-list-item>

          <info-list-item label='Trusted Seller' [lock]="isFreemium" (labelInteract)='goToSection("#app-sov")'
            type='link' [value]='data?.appOverview?.trustedSeller && data?.appOverview?.trustedSeller[0].sellerName'
            valueIcon='https://cdn.pixalate.com/sellers/icons/apn/16x16/{{data?.appOverview?.trustedSeller && data?.appOverview?.trustedSeller[0]?.sellerId}}.jpg'
            valueIconSize="16"
            [link]='data?.appOverview?.trustedSeller && data?.appOverview?.trustedSeller[0]?.sellerName !== "N/A" ? [ "/discovery/apps/list", os, "all", region ] : null'
            [linkParams]='{ trustedSellerName: data?.appOverview?.trustedSeller && data?.appOverview?.trustedSeller[0]?.sellerName }'></info-list-item>

          <info-list-item label='Incentivized Activity' [lock]="isFreemium"
            value='{{ data?.appOverview?.isIncentivizedApp | yesno:"capitalize" }}'
            valueIcon='/assets/images/icon-indicator-{{data?.appOverview?.isIncentivizedApp | yesno:"rev"}}-2.svg'
            [suggestionConfig]='{ type: "app", id: data?.appOverview?.appId, metricId: "appOverview.isIncentivizedApp" }'>
          </info-list-item>

          <info-list-item label='Last Update Date' [lock]="isFreemium"
            value='{{ data?.appOverview?.currentVersionReleaseDate | validDate:"mediumDate" }}'></info-list-item>

          <info-list-item label='Blocklist' [lock]='isFreemium'
            valueIcon='/assets/images/icon-indicator-{{data?.appOverview?.isAppBlacklisted | yesno:"rev"}}-2.svg'
            value='{{ data?.appOverview?.isAppBlacklisted | yesno:"capitalize" }}'
            valueTooltip="{{ data?.appOverview?.blackListAppReasonCodeHtml }}"></info-list-item>

          <info-list-item label='Device Availability' [show]='os === "ios"' [lock]='isFreemium'
            labelTooltip='The types of devices on which the app is available'>
            <ng-container #value>
              <span class='box-light tag box-label tag-default text-xs-right text-uppercase'
                *ngIf='data?.advertisingCapabilities?.deviceAvailability[0]?.iphone === 1' title='iPhone'>
                <i class="fa fa-mobile" aria-hidden="true"></i>
              </span>
              <span class='box-light tag box-label tag-default text-xs-right text-uppercase'
                *ngIf='data?.advertisingCapabilities?.deviceAvailability[0]?.ipad === 1' title='iPad'>
                <i class="fa fa-tablet" aria-hidden="true"></i>
              </span>
            </ng-container>
          </info-list-item>
        </div>
      </div>
      <div class='info-section' *ngIf="data?.descriptionBrandSafety?.userGeneratedContent?.length > 0 || isFreemium">
        <h5 class='info-title'>
          Interactive Elements
          <info-tooltip
            title='Interactive elements focus on what information the app has access to, what it can do with it, and whether there’s user-generated content inside it that may be outside of the control of the developer.'>
          </info-tooltip>
        </h5>
        <app-interactive-elements [data]="data?.descriptionBrandSafety?.userGeneratedContent">
        </app-interactive-elements>
      </div>
    </div>
    <div class='info-column'>
      <div class='info-section'>
        <h5 class='info-title'>
          <span>Ad Capabilities</span>
          <info-tooltip title='Detailed ad capabilities.'></info-tooltip>
        </h5>
        <app-advertising-specs [data]="data" [isFreemium]="isFreemium"
          (anchorClick)="goToSection($event)"></app-advertising-specs>
      </div>
    </div>
  </div>
</div>
<app-follow-unlock label="Additional App Details" (followClick)="follow()" *ngIf="!isFollowing && isFreemium">
</app-follow-unlock>